export var setCanvasDimensions = function setCanvasDimensions(canvas) {
  var ctx = canvas.getContext('2d');

  // Get container dimensions and device pixel ratio
  var rect = canvas.parentElement.getBoundingClientRect();
  var dpr = window.devicePixelRatio || 1;

  // Set CSS size (display size)
  Object.assign(canvas.style, {
    width: "".concat(rect.width, "px"),
    height: "".concat(rect.height, "px")
  });

  // Set actual pixel dimensions for high DPI
  Object.assign(canvas, {
    width: Math.max(1, rect.width * dpr),
    // Ensure at least 1px width
    height: rect.height * dpr
  });

  // Scale all drawing operations
  ctx.scale(dpr, dpr);
};
export var getBarDimensions = function getBarDimensions() {
  return {
    barWidth: 1.5,
    // Width of each bar in pixels
    barGap: 2 // Gap between bars in pixels
  };
};

export var calculateBarsAndSampling = function calculateBarsAndSampling(canvasWidth, barWidth, barGap) {
  var totalBars = Math.floor(canvasWidth / (barWidth + barGap));
  return {
    totalBars: totalBars
  };
};
export var calculateAmplitudeScaling = function calculateAmplitudeScaling(data, height) {
  // Find maximum amplitude in the data
  var maxAmplitude = 0;
  for (var i = 0; i < data.length; i += 1) {
    maxAmplitude = Math.max(maxAmplitude, Math.abs(data[i] || 0));
  }

  // Create scaling factors
  var amplitudeScale = height * 0.4 / (maxAmplitude || 1); // Use 40% of available height
  var minHeight = height * 0.03; // Minimum height for quiet sections

  return {
    amplitudeScale: amplitudeScale,
    minHeight: minHeight
  };
};
export var getScaledHeight = function getScaledHeight(amplitude, amplitudeScale, minHeight) {
  return Math.max(Math.abs(amplitude) * amplitudeScale, minHeight);
};
var resolveColor = function resolveColor(cssVarString) {
  // If it's not a CSS variable, return as is
  if (!cssVarString || !cssVarString.startsWith('var(--')) {
    return cssVarString;
  }

  // Server-side rendering check - return the CSS var as is if not in browser
  if (typeof document === 'undefined' || !document.documentElement) {
    return cssVarString;
  }

  // Extract the variable name without 'var(--' and ')'
  var varName = cssVarString.slice(6, -1);

  // Get the actual color value from CSS
  var computedValue = getComputedStyle(document.documentElement).getPropertyValue("--".concat(varName)).trim();

  // Return the computed value or a fallback color
  return computedValue || '#666666';
};
export var drawWaveform = function drawWaveform(canvas, data, color) {
  // Don't try to draw if we're missing essentials or not in browser
  if (!canvas || !data || !Array.isArray(data) || typeof window === 'undefined') return;

  // Set up canvas context and dimensions
  var ctx = canvas.getContext('2d');
  var rect = canvas.getBoundingClientRect();
  var width = rect.width,
    height = rect.height;
  var centerY = height / 2;

  // Get bar appearance settings
  var _getBarDimensions = getBarDimensions(),
    barWidth = _getBarDimensions.barWidth,
    barGap = _getBarDimensions.barGap;

  // Calculate how many bars will fit and how to sample the data
  var _calculateBarsAndSamp = calculateBarsAndSampling(width, barWidth, barGap),
    totalBars = _calculateBarsAndSamp.totalBars;
  var skip = Math.max(1, Math.floor(data.length / totalBars));

  // Calculate height scaling based on the data
  var _calculateAmplitudeSc = calculateAmplitudeScaling(data, height),
    amplitudeScale = _calculateAmplitudeSc.amplitudeScale,
    minHeight = _calculateAmplitudeSc.minHeight;

  // Prepare the canvas
  ctx.clearRect(0, 0, width, height);

  // Resolve CSS variable to actual color value
  var actualColor = resolveColor(color);
  ctx.fillStyle = actualColor;

  // Draw each bar
  var x = 0;
  for (var i = 0; i < data.length && x < width; i += skip) {
    // Calculate height based on amplitude
    var scaledHeight = getScaledHeight(data[i], amplitudeScale, minHeight);

    // Draw rounded rectangle bar
    ctx.beginPath();
    ctx.roundRect(x, centerY - scaledHeight, barWidth, scaledHeight * 2, [barWidth]);
    ctx.fill();

    // Move to next bar position
    x += barWidth + barGap;
  }
};